import React from 'react';
import * as productAction from './../../actions/product';
import callApi from './../../utils/apicaler';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavBar from ".././pageChild/NavBar";
import PropTypes from 'prop-types';
import axios from 'axios';
import {
  Link
} from "react-router-dom";

class Search extends React.Component{
    constructor(props){
            super(props);
            this.state = {
                status:0,
                start:0,
                end:8,
                listProducts:[],
                keyword:"",
                cartId:"",
                set:false
            }
    }
    componentDidMount(){
        callApi('5f1b03fe6c6c7f0072c612af', 'GET', null).then(res =>{
            this.setState({
                listProducts:res.data
            })
        var cart = JSON.parse(sessionStorage.getItem('products'));
          this.setState({carts:cart})
            if(cart === null){
                console.log("!")
            }else{
                cart.map((carts, index)=>{
                    this.setState({cartId: index + 1})
                })
            }

        
        })
    }

    setIncre=(s, e)=>{
        this.setState({
            end: e += 8
        })
    }

    setTime_go=()=>{
        setTimeout(()=>{ 
            this.setState({set:false})
         }, 500);
    }

    hanlSearch=(e)=>{
        this.setState({keyword:e.target.value,set:true})
        {this.setTime_go()}
    }
    showTable = (datas, status, s, e) =>{
        var result = null;
            result = datas.map((product, index)=>{
                return ( 
                    <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4" style={{paddingRight:"6px", paddingLeft: "6px"}} key={index}>
                        <Link to={`product/${product._id}`}>
                            <div className="colection1" style={{background:"#fff"}} >
                            <img src={product.imgeFile} />
                            </div>
                            <div className="title_product">
                                <p>NEW</p>
                                <b>{product.products}</b>
                                <hr/>
                                <span>Giá {product.price}.000 Vnd</span>
                            </div>
                        </Link>
                    </div> 
                )
            })
        return result
    }
    convertViToEn = (str) => {
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a"); 
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e"); 
        str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i"); 
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o"); 
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u"); 
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y"); 
        str = str.replace(/đ/g,"d");
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
        str = str.replace(/ + /g," ");
        str = str.trim(); 
        return str;
    }

    render(){
        const {status,keyword, start, end, cartId, set} = this.state;
            const listProducts = this.state.listProducts.filter((list)=>{
                return this.convertViToEn(list.products).indexOf(this.convertViToEn(keyword)) !== -1;
               
            })
        return(
            <div className="row custom_row" style={{maxWidth:"450px", margin:"auto"}}>
            <div className="row custom_row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                    <NavBar cartId={cartId} />
                  </div>
                </div>
            <div className="row custom_row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                        <div className="send_mail" style={{marginTop:"93px"}}>
                            <input autocomplete="off" style={{width:"100%"}} name="search" placeholder="Search" type="text" value={keyword} onChange={this.hanlSearch}/>
                            
                        </div>
                    </div>
                </div>
                <div className="box_main">
                    {
                        keyword === "" ? 
                        "" : 
                       set === false ? this.showTable(listProducts, status, start, end) : <div className="loading" style={{marginTop:"0", padding:"40px"}}>Loading&#8230;</div>
                    }
                    <p style={{padding:"0 57px", fontSize: "22px"}}>{listProducts.length === 0 ? `Không tiềm thấy kết quả tiềm kiếm "${keyword}"` : ""}</p>
                </div>
                
            </div>
            
        )
    }
}



export default Search;